<template lang='pug'>
//- 完成註冊區塊
div(:class='$style[`cc-popbox-cheer`]')
  IconCheerAnimate(:size='120' :color='iconColor')
  span.font-medium(:class='$style[`cc-popbox-cheer-info`]') {{ textInfo }}

</template>

<script>
// import { mapMutations } from 'vuex';
import IconCheerAnimate from '../../icon/CheerAnimate';

export default {
  components: {
    IconCheerAnimate,
  },

  props: {
    // 確認打勾圖樣顏色
    iconColor: {
      type: String,
      default: '#81e0a9',
    },
    // 訊息文字
    textInfo: {
      type: String,
      default: '',
    },
    // 是否顯示按鈕
    // button: {
    //   type: Boolean,
    //   default: false
    // },
    // 按鈕的文字
    // buttonText: {
    //   type: String,
    //   default: '確定'
    // },
    // 跳轉延遲時間
    // linkDelay: {
    //   type: Number,
    //   default: 1400
    // },
    // 跳轉POPBOX至x
    // linkPopBoxTo: {
    //   type: String,
    //   default: ''
    // },
    // 跳轉頁面至x
    // linkRouterTo: {
    //   type: String,
    //   default: ''
    // },
  },
  // data() {
  //   return {}
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popCheer.scss';
</style>
